"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const framer_motion_1 = require("framer-motion");
const PopoverPortal_1 = __importDefault(require("../Popover/PopoverPortal"));
const __1 = require("../..");
const helpers_1 = require("../../lib/helpers");
const ModalContext_1 = require("../../contexts/ModalContext");
const BackDrop_1 = __importDefault(require("../Popover/BackDrop"));
const animations_1 = require("../../lib/config/animations");
const useAddToForwardRef_1 = require("../../hocs/useAddToForwardRef");
const modalAnimations = {
    right: animations_1.SlideFromRightAnim,
    top: animations_1.SlideFromTopAnim,
    bottom: animations_1.SlideFromBottomAnim,
    left: animations_1.SlideFromLeftAnim,
};
const Modal = (props) => {
    const { isOpen, onClose, wrapClassName, children, animateFrom = 'top' } = props;
    react_1.useEffect(() => {
        // Prevent scrolling on the html body behind the modal if its open.
        if (isOpen) {
            document.body.classList.add('j-modal-is-open');
        }
        else {
            document.body.classList.remove('j-modal-is-open');
        }
    }, [isOpen]);
    const modalRef = react_1.useRef(null);
    const forwardedRef = useAddToForwardRef_1.useAddToForwardRef(props, [modalRef]);
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    primitiveProps.ref = forwardedRef;
    const contextValue = react_1.useMemo(() => ({ onClose, inModal: true, isOpen }), [isOpen, onClose]);
    const modalWrapClassName = classnames_1.default('j-modal-wrap', wrapClassName);
    return (react_1.default.createElement(ModalContext_1.ModalContext.Provider, { value: contextValue },
        react_1.default.createElement(PopoverPortal_1.default, { selector: "body" },
            react_1.default.createElement(BackDrop_1.default, { isOpen: isOpen, onClick: onClose }),
            react_1.default.createElement(framer_motion_1.AnimatePresence, null, isOpen && (react_1.default.createElement(framer_motion_1.motion.div, { className: modalWrapClassName },
                react_1.default.createElement(framer_motion_1.motion.div, Object.assign({}, modalAnimations[animateFrom], primitiveProps), children)))))));
};
exports.default = __1.withJourney('j-modal', Modal);
